import React, { useState } from "react";
import { ArrowDownOutlined, CheckCircleFilled, LockOutlined } from "@ant-design/icons";
import { PaymentsTab } from "./PaymentsTab";
import { OperationsHandoverPanel } from "../../../operations-v2/views/handover/OperationsHandoverPanel";
import { useQv4Theme } from "../../helpers";
import "./payment-handover-tab.css";

export function PaymentHandoverTab({ paymentProps, handoverProps, paymentVisible = false }) {
  const { t, isDark } = useQv4Theme();
  const [handoverStatus, setHandoverStatus] = useState({ loading: true, eligible: false, state: null, reason: "Checking handover readiness…" });
  const ready = handoverStatus.eligible || handoverStatus.state === "authorized";

  return (
    <div className="payment-handover-workflow">
      {paymentVisible && <section className="payment-handover-pane payment-handover-payment-pane" aria-label="Payments">
        <div className="payment-handover-section-heading" style={{ background: t.headerBg, borderColor: t.border }}>
          <div>
            <strong style={{ color: t.text }}>1. Payments</strong>
            <span style={{ color: t.textSub }}>Collect and verify the customer payment.</span>
          </div>
        </div>
        <div className="payment-handover-pane-content"><PaymentsTab {...paymentProps} /></div>
      </section>}

      <div
        className={`payment-handover-relationship ${ready ? "is-ready" : "is-blocked"}`}
        style={{
          "--relationship-bg": ready ? (isDark ? "rgba(82,196,26,.15)" : "#f6ffed") : t.headerBg,
          "--relationship-border": ready ? "#95de64" : t.border,
          "--relationship-text": ready ? "#389e0d" : t.textSub,
        }}
        role="status"
      >
        <span className="payment-handover-relationship-line" />
        <span className="payment-handover-relationship-pill">
          {ready ? <CheckCircleFilled /> : <LockOutlined />}
          <span>{ready ? (handoverStatus.state === "authorized" ? "Operations handover complete" : "Payment stage ready · Operations handover enabled") : handoverStatus.reason}</span>
          {!ready && <ArrowDownOutlined />}
        </span>
        <span className="payment-handover-relationship-line" />
      </div>

      <section className={`payment-handover-pane payment-handover-operations-pane ${ready ? "is-ready" : "is-blocked"}`} aria-label="Operations handover">
        <div className="payment-handover-section-heading" style={{ background: ready ? (isDark ? "rgba(82,196,26,.11)" : "#f6ffed") : t.headerBg, borderColor: ready ? "#95de64" : t.border }}>
          <div>
            <strong style={{ color: ready ? "#389e0d" : t.textSub }}>{paymentVisible ? "2" : "1"}. Operations Handover</strong>
            <span style={{ color: t.textSub }}>{ready ? "Complete the transfer of responsibility to Operations." : "Complete the requirements below to enable handover."}</span>
          </div>
        </div>
        <div className="payment-handover-pane-content">
          <OperationsHandoverPanel {...handoverProps} embedded onStatusChange={setHandoverStatus} />
        </div>
      </section>
    </div>
  );
}
